import { render, staticRenderFns } from "./TabRides.vue?vue&type=template&id=5c417276&"
import script from "./TabRides.vue?vue&type=script&lang=js&"
export * from "./TabRides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports